import React, { ReactNode } from 'react';

export type InputProps = {
  'data-testid': string,
  className: string,
  disabled?: boolean,
  [key: string]: any,
};
type Props = {
  prepend: ReactNode,
  append?: ReactNode,
  active: boolean,
  touched?: boolean,
  error?: string,
  submitError?: string,
  dirtySinceLastSubmit?: boolean,
  disabled?: boolean,
  className?: string,
  input?: (inputProps: InputProps) => ReactNode,
  [key: string]: any,
};

const InputGroup = ({
  prepend,
  append,
  active,
  touched,
  error,
  submitError,
  dirtySinceLastSubmit,
  disabled,
  className,
  input,
  ...rest
}: Props) => {
  const inputProps = {
    'data-testid': 'input-group-input',
    className: `form-control ${className || ''}`,
    disabled,
    ...rest,
  };
  return (
    <div className="form-group">
      <div
        className={`input-group${active ? ' input-group-focus' : ''}${
          (touched && error) || (!dirtySinceLastSubmit && submitError) ? ' is-invalid' : ''
        }`}
      >
        {prepend && (
          <div className="input-group-prepend">
            <div className={`input-group-text${disabled ? ' disabled' : ''}`}>{prepend}</div>
          </div>
        )}
        {(input && typeof input === 'function' && input(inputProps)) || <input {...inputProps} />}
      </div>
      {error && submitError && <div className="invalid-feedback d-block">{error}</div>}
    </div>
  );
};

export default InputGroup;
